import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { startCheckout } from "@/lib/checkout";
import PricingTiers from "@/components/PricingTiers";
import { Lock } from "lucide-react";

export default function PremiumRequired({ feature = "This feature" }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const onCta = () => {
    if (!user) { navigate("/login"); return; }
    startCheckout();
  };

  return (
    <div data-testid="premium-required" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center max-w-xl mx-auto mb-10 animate-fade-up">
        <div className="w-14 h-14 rounded-2xl bg-black/5 flex items-center justify-center mx-auto mb-5">
          <Lock className="w-6 h-6 text-nerd-light" />
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mb-3">{feature} is Premium</h1>
        <p className="text-nerd-light/55 text-lg">Upgrade to unlock the AI Creative Agent, meal planner and supplies. €8.99/month, cancel anytime.</p>
      </div>
      <PricingTiers
        isPremium={false}
        isLoggedIn={!!user}
        onPremiumCta={onCta}
        ctaLabel="Upgrade now — €8.99/mo"
      />
    </div>
  );
}
